import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useAnalysisDefinitionStore } from '../state/useAnalysisDefinitionStore';
import type { UseAnalysisRevertModalArgs, UseAnalysisRevertModalResult } from '../types';

// Revert is in-memory and instant. Hold the modal visible briefly so the
// user perceives the transition before the UI updates.
const REVERT_VISUAL_DELAY_MS = 400;

export const useAnalysisRevertModal = ({
  onClose,
}: UseAnalysisRevertModalArgs): UseAnalysisRevertModalResult => {
  const { formatMessage } = useIntl();
  const revert = useAnalysisDefinitionStore((s) => s.revert);

  // Fire-and-close exactly once on mount; the cleanup clears the timer if the
  // user navigates away mid-delay.
  useEffect(
    () => {
      revert();
      const timer = setTimeout(onClose, REVERT_VISUAL_DELAY_MS);
      return () => clearTimeout(timer);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    title: formatMessage({ id: 'analysisDetail.revertModal.title' }),
    loadingTitle: formatMessage({ id: 'analysisDetail.revertModal.loadingTitle' }),
    loadingText: formatMessage({ id: 'analysisDetail.revertModal.loadingText' }),
  };
};
